var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 7.08497C4.935 7.08497 4.065 6.21997 4.065 5.14997C4.065 4.07997 4.935 3.21997 6 3.21997C7.065 3.21997 7.935 4.08497 7.935 5.15497C7.935 6.22497 7.065 7.08497 6 7.08497ZM6 3.96997C5.35 3.96997 4.815 4.49997 4.815 5.15497C4.815 5.80997 5.345 6.33997 6 6.33997C6.655 6.33997 7.185 5.80997 7.185 5.15497C7.185 4.49997 6.65 3.96997 6 3.96997Z",
    fill: "#0A8A95"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6 11.38C5.26 11.38 4.515 11.1 3.935 10.545C2.46 9.125 0.829997 6.86 1.445 4.165C2 1.72 4.135 0.625 6 0.625C6 0.625 6 0.625 6.005 0.625C7.87 0.625 10.005 1.72 10.56 4.17C11.17 6.865 9.54 9.125 8.065 10.545C7.485 11.1 6.74 11.38 6 11.38ZM6 1.375C4.545 1.375 2.675 2.15 2.18 4.33C1.64 6.685 3.12 8.715 4.46 10C5.325 10.835 6.68 10.835 7.545 10C8.88 8.715 10.36 6.685 9.83 4.33C9.33 2.15 7.455 1.375 6 1.375Z",
    fill: "#0A8A95"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.2ccc5cd5fea6d0754c705b30e7ee8e59.svg";
export { ForwardRef as ReactComponent };